import { FileUploadStatus } from '../hooks/useFileUpload';
import { DocumentEvent, DocumentEventTypes } from '../models/BackendEvents';
import { DocumentInfoModel } from '../models/ChatTypes';

export enum Status {
    Success = 'success',
    Warning = 'warning',
    Danger = 'danger',
    Default = 'default',
    Info = 'info'
}

export function getStatusLabelType(status: FileUploadStatus): Status {
    switch (status.toLowerCase()) {
        case FileUploadStatus.Ready.toLowerCase():
            return Status.Success;
        case FileUploadStatus.Processing.toLowerCase():
            return Status.Warning;
        case FileUploadStatus.Error.toLowerCase():
            return Status.Danger;
        case FileUploadStatus.Uploaded.toLowerCase():
            return Status.Info;
        default:
            return Status.Default;
    }
}

export const getFinalDocumentStatus = <T extends Pick<DocumentInfoModel, 'id' | 'state'>>(document: T, events: Record<string, DocumentEvent>): FileUploadStatus => {
    const { id, state } = document;
    const fallbackStatus = state?.status || FileUploadStatus.Idle;

    // If file status is uploaded, this indicates that document processing was not requested and there for, we will not consider the events.
    if (fallbackStatus === FileUploadStatus.Uploaded) {
        return fallbackStatus;
    }
    if (state?.status === FileUploadStatus.Ready) {
        return FileUploadStatus.Ready;
    }

    const event = events[id]?.type;
    let eventStatus = FileUploadStatus.Processing;
    if (event === DocumentEventTypes.processed) eventStatus = FileUploadStatus.Ready;
    else if (event === DocumentEventTypes.failed) eventStatus = FileUploadStatus.Error;

    return event ? eventStatus : fallbackStatus;
};